/* eslint-disable @typescript-eslint/no-use-before-define */
import DrawerAlerts from 'Components/alerts/components/DrawerAlerts';
import GlobalSearch from 'Components/globalSearch/components/GlobalSearch';
import NavBarPrimary, { chatActions, chatStates } from 'Components/layout/headers/NavBarPrimary';
import styled from 'styled-components';
import {
  boxShadow, maxMobile, noPersonImage, primaryColor, primaryFont, primaryHeadingColor,
  SecondaryColorTwo, secondaryFont, smMobile, TermsAndConditions, userPlaceHolder, wLight, wMBold, wMedium,
} from 'Utils/utilsStyle';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import { useEffect, useRef, useState } from 'react';
import SmallButton from 'Components/common/components/SmallButton';
import CameraIcon from 'Components/common/assets/svgIcons/CameraIcon';
import { actions as helperActions, actions as flurryActions } from 'Slice/HelperSlice';
import {
  Form, FormikProvider, useFormik,
} from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import * as _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import BackIcon from 'Components/common/assets/svgIcons/BackIcon';
import InputWithRef from 'Components/common/components/InputWithRef';
import Input from 'Components/auth/components/Input';
import PasswordValid from 'Components/auth/components/PasswordValid';
import { actions as settingsActions } from 'Slice/SettingsSlice';
import { actions as profileConfirmationActions } from 'Slice/ProfileConfirmationSlice';
import {
  selectLoading,
  selectSubmitVerificationCodeData,
  selectSubmitVerificationCodeLoaded, selectSubmitVerificationCodeLoading, selectUpdated,
} from 'Selector/SettingsSelector';
import {
  convertToFile, generateRandomFileName, getLocalStorageValue, IsTablet, setLocalStorageValue,
  valueToObject,
} from 'Utils/UtilityFunctions';
import { Switch } from 'antd';
import { SUPPORT_MAIL } from 'Utils/Constants';
import { selectDisclessPersonality, selectShowGlobalGilroy, selectUserPhone } from 'Selector/GlobalSearchContentSelector';
import { actions as UiAction } from 'Slice/UISlice';
import PhoneNumberInput from 'Components/auth/components/PhoneNumberInput';
import CodeVerificationPopup from 'Pages/auth/CodeVerificationPopup';
import { Gilroy } from 'gilroy-global';
import { useGilroy } from 'Utils/hooks/useGilroy';

const Wrapper = styled.div`
  background-color: #fff;
  box-shadow: ${boxShadow};
  border-radius: 16px;
  padding: 23px;
  margin: 70px 0px;
  width: 537px;
  margin: auto;
  margin-bottom: 50px;
  @media all and (max-width: ${maxMobile}) {
    width: 95%;
  }
  .heading-div {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    h1.heading{
      color: ${primaryHeadingColor};
      font-weight: ${wMedium};
      font-family: ${secondaryFont};
      font-size: 28px;
      line-height: 1.679;
      margin: 10px 0 0 18px;
    }
    .profile-map-button {
      background-color: #fff;
      border-radius: 25px;
      border: 1.5px solid ${primaryColor};
      padding: 7px 15px;
      font-family: ${primaryFont};
      font-weight: ${wMedium};
      color: ${primaryColor};
      font-size: 16px;
      line-height: 24px;
      margin-top: 12px;
      margin-bottom: 4px;
      cursor: pointer;
      @media all and (max-width: ${smMobile}) {
        font-size: 14px;
        padding: 5px 10px;
        margin-bottom: 10px;
      }
    }
  }
  .card_content{
    width: 425px;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media all and (max-width: ${maxMobile}) {
      width: 100%;
    }
    .person_image{
      position: relative;
      .User_Image{
        width: 170px;
        border-radius: 50%;
        height: 170px;
      }
      svg{
        cursor: pointer;
        position: absolute;
        bottom: 10px;
        right: 0px;
        z-index: 1;
      }
    }
    form{
      width: 100%;
      display: flex;
      flex-direction: column;

      label{
        font-weight: ${wMedium};
        font-family: ${primaryFont};
        font-size: 18px;
        letter-spacing: -0.5;
      }
      .name_container,.email_container,.password_container{
        position: relative;

        .error-msg{
          position: absolute;
          top: 100px;
          right: 0px;
        }
        .name_edit,.email_edit,.change_password_edit{
          position: absolute;
          top: 28px;
          right: 0;
          color: ${primaryColor};
          font-weight: ${wMBold};
          font-family: ${primaryFont};
          font-size: 16px;
          letter-spacing: -0.4;
          line-height: 1.25;
          cursor: pointer;
        }
        .password-valid-popover{
          right: 3px;
          .ant-popover {
            .ant-popover-inner {
              padding: 0px;
            }
          }
        }
      }
      .support-link{
        display: inline-block;
        width: fit-content;
        margin-left: auto;
        color: ${SecondaryColorTwo};
        font-weight: ${wMedium};
        font-family: ${primaryFont};
        font-size: 14px;
        letter-spacing: -0.39;
        display: inline-block;
        /* margin-top: 30px; */
        text-decoration: underline;
        text-align: end;
        @media all and (max-width: ${maxMobile}) {
          margin-top: 0px;
        }
      }
      .terms_link{
          display: inline-block;
          width: fit-content;
          margin: 0 auto;
          color: ${SecondaryColorTwo};
          font-weight: ${wMedium};
          font-family: ${primaryFont};
          font-size: 14px;
          letter-spacing: -0.39;
          display: inline-block;
          text-decoration: underline;
          text-align: center;
          margin-right: 199px;
          @media all and (max-width: ${maxMobile}) {
            margin: 0px;
          }
      }
      .submit_btn{
        margin: 30px 0 32px 0;
      }
    }
  }
  .extended-box {
    margin-left: -36px;
    margin-right: -36px;
    margin-bottom: -25px;
    margin-top: 5px;
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 1px;
    position: relative;
    border-radius: 0 0 24px 24px;
    .password + span {
      top: 15px;
    }
  }
`;

const Image = styled.div<{ image: string }>`
 width: 100%;
 height: 100%;
 border-radius: 50%;
 background-image: url(${(props) => props.image});
 background-position:center;
 background-size:cover;
 background-color: #fff;
`;

const Footer = styled.div`
 display: inline-flex;
 justify-content: space-between;
 margin-top: 30px;
`;

const DailyIQAlerts = styled.div`
  display: inline-flex;
  justify-content: space-between;
  padding: 20px 0px;
  .dailyiq-alert-left-wrapper {
    gap: 10px;
    .customize-text {
      color: ${primaryColor};
      font-family: ${primaryFont};
      font-weight: ${wLight};
      font-size: 14px;
      text-decoration: underline;
      cursor: pointer;
      letter-spacing: -0.39px;
    }
  }
  .input-label {  
    color: #5e7079;
    font-size: 18px;
    font-weight: ${wMedium};
    font-family: ${primaryFont};
  }
  .switch-div {
    rotate: 0deg;
    .switch-class {
      &.ant-switch-checked {
      .ant-switch-inner {
        margin-inline-start: -36px;
      }
    }
      .ant-switch-inner {
        rotate: 0deg;
        padding-inline-start: inherit;
        padding-inline-end: 0px;
        padding-inline-start: 18px;
      }
    }
  }
  .default-label {
   color: #5e7079;
    font-size: 14px;
    font-weight: ${wMedium};
    font-family: ${primaryFont};
    margin-right:10px;
    @media all and (max-width: ${smMobile}) {
        display: none;
      }
  }
`;

const passwordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%#*?&])[A-Za-z\d@$!#%*?&]{12,}$/;

const Settings = function Settings() {
  const navigate = useNavigate();
  const [baseURL, setBaseURL] = useState('');
  const { gilroyStates, gilroyActions } = useGilroy();
  const { saveUrl: savedUrlV2 } = chatStates;
  const [file, setFile] = useState<File>();
  const [disableName, setDisableName] = useState(true);
  const [disablePhoneNumber, setDisablePhoneNumber] = useState(true);
  const [inputPicture, setInputPicture] = useState('');
  const [image, setImage] = useState({ preview: '' });
  const dispatch = useDispatch();
  const formLoading: boolean = useSelector(selectLoading);
  const updated: boolean = useSelector(selectUpdated);
  const showGlobalGilroy = useSelector(selectShowGlobalGilroy);
  const userContactNumber = useSelector(selectUserPhone);
  const currentUrl = window.location.href;
  const [disablePassword, setDisablePassword] = useState(true);
  const [hidePassword, setHidePassword] = useState(true);
  const [currentValue, setCurrentValue] = useState(getLocalStorageValue('subscription') === 'False');
  const [showPasswords, setShowPasswords] = useState({
    password: false,
    newpassword: false,
    repassword: false,
  });
  const [showPasswordValidate, setShowPasswordValidate] = useState(false);
  const nameRef = useRef<HTMLInputElement>(null);
  const mailRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLDivElement | null>(null);
  const initialState = {
    fullname: getLocalStorageValue('fullname'),
    email: getLocalStorageValue('email'),
    phone: userContactNumber,
    password: '',
    newpassword: '',
    repassword: '',
    subscription: getLocalStorageValue('subscription'),
  };
  const [profilePic, setProfilePic] = useState(getLocalStorageValue('profilePic') || userPlaceHolder);
  const [showCodeVerificationPopup, setShowCodeVerificationPopup] = useState(false);
  const [isNumberValid, setIsNumberValid] = useState<boolean>(true);
  const [activePhoneNumber, setActivePhoneNumber] = useState<boolean>(false);
  const disclessPersonality = useSelector(selectDisclessPersonality);
  const loading = useSelector(selectSubmitVerificationCodeLoading);
  const loaded = useSelector(selectSubmitVerificationCodeLoaded);
  const responseData = useSelector(selectSubmitVerificationCodeData);

  const onSelectFile = (img: File) => {
    const reader = new FileReader();
    reader.readAsDataURL(img);
    reader.onloadend = () => {
      setBaseURL(reader.result as string);
    };
  };

  useEffect(() => {
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('settings_page_loaded', 0),
    ));

    const handleStorageChange = () => {
      setProfilePic(getLocalStorageValue('profilePic') || '');
    };
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (savedUrlV2 !== currentUrl) {
      dispatch(UiAction.isShowGilroyGlobalToggle(false));
      chatActions.setShowLibrary(true);
      chatActions.setShowExamplePrompts(false);
      chatActions.resetChatHistory();
      chatActions.setSelectedConversationId(-1);
      chatActions.setHistoryPanelOpened(false);
    } else {
      chatActions.setSaveUrl('');
      chatActions.setSaveProfileName('');
    }
  }, []);

  useEffect(() => {
    if (baseURL) {
      const filename = generateRandomFileName();
      setFile(convertToFile(baseURL, filename));
    }
  }, [baseURL]);

  const isPictureTypeValid = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fileName = e.target.value;
    const idxDot = fileName.lastIndexOf('.') + 1;
    const extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile === 'jpg' || extFile === 'jpeg' || extFile === 'png') return true;
    return false;
  };

  const isPictureSizeValid = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length && e.target.files[0].size < 10e6) return true;
    return false;
  };

  const handlePictureChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!isPictureTypeValid(e)) {
      dispatch(helperActions.setNotification({
        message: 'Only Image file should be selected',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
    } else if (!isPictureSizeValid(e)) {
      dispatch(helperActions.setNotification({
        message: 'Image size should be less than 10 MB',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
    } else if (e.target.files && e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
      });
      onSelectFile(e.target.files[0]);
    }
    setInputPicture('');
  };

  const ValidationFormSchema = Yup.object().shape({
    fullname: Yup.string().when('type', {
      is: () => disableName,
      then: Yup.string(),
      otherwise: Yup.string().required('Required'),
    }),
    password: Yup.string().when('type', {
      is: () => hidePassword,
      then: Yup.string(),
      otherwise: Yup.string().required('Required'),
    }),
    newpassword: Yup.string().when('type', {
      is: () => hidePassword,
      then: Yup.string().matches(passwordRegExp, '.'),
      otherwise: Yup.string().matches(passwordRegExp, '.').required('Required'),
    }),
    repassword: Yup.string().when('type', {
      is: () => hidePassword,
      then: Yup.string().oneOf([Yup.ref('newpassword'), null], 'Password does not match'),
      otherwise: Yup.string().oneOf([Yup.ref('newpassword'), null], 'Password does not match').required('Required'),
    }),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialState,
    validationSchema: ValidationFormSchema,
    onSubmit: async (values) => {
      if (values.fullname?.trim() === '') {
        await setInputEmpty();
        return;
      }

      if (!_.isEqual(values, initialState) || file) {
        const data = {
          fullname: values.fullname?.trim().replace(/  +/g, ' ') || '',
          email: values.email,
          ...(values.phone ? { phone: values.phone } : {}),
          ...(values.password ? { old_password: values.password } : {}),
          ...(values.newpassword ? { password: values.newpassword } : {}),
          ...(file ? { profilepic: file } : {}),
          subscription: getLocalStorageValue('subscription') || '',
        };

        // length check is for country code
        if ((!initialState?.phone && values?.phone?.length < 3) || values?.phone === initialState?.phone) {
          dispatch(settingsActions.updateSetting(data));
          if (file) setFile(undefined);
        }

        if ((!initialState?.phone && isNumberValid) || ((values?.phone !== initialState?.phone) && isNumberValid)) {
          dispatch(settingsActions.verifyCode({
            phone: values.phone,
            isSetting: true,
            twoFactorAuthentication: true,
          }));
        }
      }
    },
  });

  const {
    values,
    errors,
    touched,
    handleChange,
    handleSubmit,
    handleBlur,
    isSubmitting,
    isValid,
    resetForm,
    setValues,
    setFieldTouched,
    validateForm,
  } = formik;
  const setInputEmpty = async () => {
    await setValues({
      ...values, fullname: '',
    });
  };

  const handleChangePassword = async () => {
    setDisablePassword(!disablePassword);
    setHidePassword(!hidePassword);
    await setFieldTouched('password', false, false);
    await setFieldTouched('newpassword', false, false);
    await setFieldTouched('repassword', false, false);
    setTimeout(
      () => {
        passwordRef.current?.focus();
      },
      200,
    );
    if (!hidePassword) {
      await setValues({
        ...values, password: '', newpassword: '', repassword: '',
      });

      setTimeout(
        async () => {
          await validateForm(values);
        },
        500,
      );
    }
  };

  useEffect(() => {
    if (loaded) {
      setDisablePhoneNumber(true);
    }
  }, [loaded, responseData]);

  const handleNameEdit = async () => {
    setDisableName(!disableName);
    setTimeout(
      () => nameRef.current?.focus(),
      200,
    );
    if (!disableName) {
      await setValues({
        ...values, fullname: initialState.fullname,
      });
      await setFieldTouched('fullname', false, false);
      setTimeout(
        async () => {
          await validateForm(values);
        },
        500,
      );
    }
  };
  const data = {
    fullname: values.fullname?.trim().replace(/  +/g, ' ') || '',
    email: values.email,
    ...(values.password ? { old_password: values.password } : {}),
    ...(values.newpassword ? { password: values.newpassword } : {}),
    ...(values.phone ? { phone: values.phone } : {}),
    ...(file ? { profilepic: file } : {}),
    subscription: getLocalStorageValue('subscription') || '',
  };
  const stopEmail = () => {
    setCurrentValue(!currentValue);
    if (currentValue) {
      setLocalStorageValue('subscription', 'True');
    } else {
      setLocalStorageValue('subscription', 'False');
    }
    const toggleData = {
      fullname: '',
      email: '',
      old_password: '',
      password: '',
      profilepic: '',
      phone: initialState.phone,
      subscription: getLocalStorageValue('subscription') || '',
      toggle: true,
    };
    dispatch(settingsActions.updateSetting(toggleData));
  };

  const updateSetting = () => {
    dispatch(settingsActions.updateSetting(data));
  };

  const disableSubmitButton = () => (!file && _.isEqual(values, initialState))
    || (!_.isEqual(values, initialState) && !isValid) || isSubmitting || !isValid
    || formLoading || loading;

  useEffect(() => {
    if (updated) {
      setHidePassword(true);
      setDisableName(true);
      setDisablePassword(true);
      setDisablePhoneNumber(true);
      resetForm();
    }
  }, [updated, getLocalStorageValue('fullname')]);

  const showConfirmationPopup = () => {
    dispatch(profileConfirmationActions.setPopupVisible(true));
  };
  const handlePhoneChange = async (value: string) => {
    setActivePhoneNumber(true);
    await setValues({ ...values, phone: value });
  };

  const handlePhoneNumberEdit = async () => {
    setDisablePhoneNumber(!disablePhoneNumber);
    if (!disablePhoneNumber) {
      await setValues({
        ...values, phone: initialState.phone,
      });
    }
    if (phoneRef?.current) {
      const phoneInputElement = phoneRef?.current.querySelector('input');
      if (phoneInputElement) {
        setTimeout(
          () => {
            phoneInputElement.focus();
          },
          200,
        );
      }
    }
  };

  const handleClose = async () => {
    setShowCodeVerificationPopup(false);
    setDisablePhoneNumber(true);
    await setValues({ ...values, phone: initialState?.phone });
  };

  const redirectToDailyIQ = () => {
    navigate('/dailyiq');
  };
  return (
    <>
      <NavBarPrimary headerClassName="headers-space box-shadow  no-overflow-on-header">
        <div className="left-side-wrap">
          <BackIcon onClick={() => navigate(-1)} />
          <h1 className="heading">Settings</h1>
        </div>
        <div className="right-side-wrap">
          <GlobalSearch iconMode={IsTablet()} />
          <DrawerAlerts />
          <AccountPopOver />
        </div>
      </NavBarPrimary>
      <div className="container">
        <Wrapper>
          <div className="heading-div">
            <h1 className="heading">Profile</h1>
            <span
              tabIndex={0}
              role="button"
              onClick={showConfirmationPopup}
              onKeyPress={showConfirmationPopup}
              className="profile-map-button"
            >
              Map your profile
            </span>
          </div>
          <div className="card_content">
            <div className="person_image">
              <label aria-label="profile-pic" htmlFor="camera-icon">
                <input
                  accept="image/*"
                  id="camera-icon"
                  type="file"
                  value={inputPicture}
                  onChange={handlePictureChange}
                  style={{ display: 'none' }}
                />
                <CameraIcon />
              </label>
              {image.preview ? (
                <img src={disclessPersonality ? noPersonImage : image.preview} alt="preview" className="User_Image" />
              ) : <Image className="User_Image" image={disclessPersonality ? noPersonImage : profilePic} />}
            </div>
            <FormikProvider value={formik}>
              <Form noValidate onSubmit={handleSubmit}>
                <div className="name_container">
                  <span aria-hidden="true" className="name_edit" onClick={handleNameEdit}>
                    {disableName ? 'Edit' : 'Cancel'}
                  </span>
                  <InputWithRef
                    inputLabel="Full Name"
                    inputName="fullname"
                    isDisabled={disableName}
                    inputType="text"
                    inputPlaceholder="Enter Full Name…"
                    inputValue={values.fullname || ''}
                    onInputChange={handleChange}
                    onInputBlur={handleBlur}
                    error={touched.fullname && errors.fullname ? errors.fullname : ''}
                    ref={nameRef}
                    inputClassName="name"
                    isPassword={false}
                    onInputTogglePassword={() => { }}
                    autocomplete=""
                    errorIcon={false}
                    maxLength={45}
                  />
                </div>
                <div className="email_container">
                  <InputWithRef
                    inputLabel="Email"
                    inputName="email"
                    isDisabled
                    inputType="text"
                    inputPlaceholder="Enter Email…"
                    inputValue={values.email || ''}
                    onInputChange={handleChange}
                    onInputBlur={handleBlur}
                    error={touched.email && errors.email ? errors.email : ''}
                    ref={mailRef}
                    inputClassName="email"
                    isPassword={false}
                    onInputTogglePassword={() => { }}
                    autocomplete=""
                    errorIcon={false}
                    maxLength={45}
                  />
                </div>
                <div className="name_container">
                  <PhoneNumberInput
                    isDisabled={disablePhoneNumber}
                    label="Phone number"
                    id="phoneNumber"
                    ref={phoneRef}
                    inputValue={values.phone || ''}
                    onChange={handlePhoneChange}
                    onPhoneNumberEdit={handlePhoneNumberEdit}
                    isValid={isNumberValid}
                    setIsValid={setIsNumberValid}
                    activePhoneNumber={activePhoneNumber}
                  />
                </div>
                <div className="password_container">
                  <span aria-hidden="true" className="change_password_edit" onClick={handleChangePassword}>{hidePassword ? 'Change Password' : 'Cancel'}</span>
                  <InputWithRef
                    inputValue={values.password}
                    inputClassName="password eye_hide padding-right-password"
                    isPassword
                    isDisabled={disablePassword}
                    inputName="password"
                    error={touched.password && errors.password ? errors.password : ''}
                    inputLabel="Password *"
                    inputType={showPasswords.password ? 'text' : 'password'}
                    inputPlaceholder={hidePassword ? '*********' : ''}
                    onInputTogglePassword={() => {
                      setShowPasswords({
                        ...showPasswords,
                        password: !showPasswords.password,
                      });
                    }}
                    onInputChange={handleChange}
                    onInputBlur={handleBlur}
                    autocomplete="new-password"
                    ref={passwordRef}
                    errorIcon={false}
                    maxLength={45}
                  />
                </div>
                <div className="password_container" hidden={hidePassword}>
                  <PasswordValid
                    open={showPasswordValidate}
                    password={values.newpassword}
                  />
                  <Input
                    inputLabel="Type your new password *"
                    inputPlaceholder="Type your new password..."
                    inputType={showPasswords.newpassword ? 'text' : 'password'}
                    inputName="newpassword"
                    inputClassName="newpassword"
                    inputValue={values.newpassword}
                    error={touched.newpassword && errors.newpassword ? errors.newpassword : ''}
                    onInputChange={handleChange}
                    isPassword
                    onInputFocus={() => setShowPasswordValidate(true)}
                    onInputBlur={(e) => {
                      handleBlur(e);
                      setShowPasswordValidate(false);
                    }}
                    onInputTogglePassword={() => {
                      setShowPasswords({
                        ...showPasswords,
                        newpassword: !showPasswords.newpassword,
                      });
                    }}
                    autocomplete="new-password"
                  />
                </div>
                <div className="password_container" hidden={hidePassword}>
                  <Input
                    inputLabel="Retype your new password *"
                    inputPlaceholder="Retype your new password…"
                    inputType={showPasswords.repassword ? 'text' : 'password'}
                    inputName="repassword"
                    inputClassName="repassword"
                    inputValue={values.repassword}
                    error={touched.repassword && errors.repassword ? errors.repassword : ''}
                    isPassword
                    onInputChange={handleChange}
                    onInputBlur={handleBlur}
                    onInputTogglePassword={() => {
                      setShowPasswords({
                        ...showPasswords,
                        repassword: !showPasswords.repassword,
                      });
                    }}
                    autocomplete="new-password"
                  />
                </div>
                <DailyIQAlerts>
                  <div className="d-flex align-items-center dailyiq-alert-left-wrapper">
                    <span
                      className="input-label"
                    >
                      Daily IQ Alert
                    </span>
                    <span onClick={redirectToDailyIQ} className="customize-text">Customize</span>
                  </div>
                  <div className="d-flex switch-div align-items-center">
                    <span className="default-label">By default</span>
                    <Switch
                      className="switch-class"
                      checkedChildren="Off"
                      unCheckedChildren="On"
                      checked={currentValue}
                      onClick={() => stopEmail()}
                    />
                  </div>
                </DailyIQAlerts>
                <SmallButton
                  className="submit_btn"
                  buttonType="submit"
                  title={`${!(formLoading || loading) ? 'Save' : 'Saving...'}`}
                  disabled={disableSubmitButton()}
                />
                <Footer>
                  <a
                    className="terms_link"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={TermsAndConditions}
                    title="Terms of Use"
                  >
                    Terms and Conditions
                  </a>
                  <a
                    className="support-link"
                    href={SUPPORT_MAIL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Email Support
                  </a>
                </Footer>
              </Form>
            </FormikProvider>
          </div>
        </Wrapper>
      </div>
      {showGlobalGilroy
        ? (
          <Gilroy gilroyStates={gilroyStates} gilroyActions={gilroyActions} />
        ) : null}
      {showCodeVerificationPopup
        ? (
          <CodeVerificationPopup
            phone={values.phone || ''}
            description="A verification code has been sent to your provided phone number."
            onClose={handleClose}
            setShowCodeVerificationPopup={setShowCodeVerificationPopup}
            updateSetting={updateSetting}
          />
        )
        : null}
    </>
  );
};

export default Settings;
